import request from '../request'

export default {
  getWFSData(bbox, fromDate, toDate, maxCloudCoverage, priority) {
    return request.get(`satelite_imagen/${bbox}/${fromDate}/${toDate}/${maxCloudCoverage}/${priority}`)
  }
}
